import {GET_SET_STOCK_QUOTATION_DATA,GET_SET_STOCK_NEWS_DATA} from "./actions.type";
import {stock} from "@/service/stock";

function initState() {
    return {}
}

const state = initState();

const actions = {
    async [GET_SET_STOCK_QUOTATION_DATA]({ }, data) {
      let response = await stock.getStockQuotationData(data);
      return response;
    },

    async [GET_SET_STOCK_NEWS_DATA]({ }, lang) {
      let response = await stock.getStockNewsData(lang);
      return response;
    },
  };
  

const mutations = {};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};
